import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import api from '../lib/api';
import { Badge } from '../components/ui/badge';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';

const KIND = { document_request: 'Documents', bas_submission: 'BAS / IAS', rental_request: 'Rental', questionnaire: 'Questionnaire', further_info: 'Tax return',
  engagement_letter: 'Engagement letter', nomination: 'ATO nomination', change_request: 'Your change request', client_action: 'Action', director_id: 'Director ID' };
const d = (s) => (s ? new Date(s).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' }) : null);

const ActionComplete = ({ item, onDone }) => {
  const [text, setText] = useState('');
  const [file, setFile] = useState(null);
  const send = async () => {
    const fd = new FormData(); fd.append('response', text); if (file) fd.append('file', file);
    try { await api.post(`/api/portal/client-actions/${item.ref_id}/complete`, fd, { headers: { 'Content-Type': 'multipart/form-data' } }); toast.success('Sent to your accountant'); onDone(); } catch (e) { toast.error(e.response?.data?.detail || 'Could not send'); }
  };
  return (
    <div className="flex flex-wrap gap-2 mt-2">
      <Input className="max-w-xs" placeholder="Reply (optional)" value={text} onChange={(e) => setText(e.target.value)} data-testid={`action-reply-${item.ref_id}`} />
      <input type="file" onChange={(e) => setFile(e.target.files[0])} data-testid={`action-file-${item.ref_id}`} />
      <Button size="sm" onClick={send} data-testid={`action-complete-${item.ref_id}`}>Mark done</Button>
    </div>
  );
};

export default function RequestsTasks() {
  const [items, setItems] = useState(null);
  const load = () => api.get('/api/portal/requests').then((r) => setItems(r.data)).catch(() => toast.error('Could not load'));
  useEffect(() => { load(); }, []);
  return (
    <div className="p-6 lg:p-10 space-y-8" data-testid="requests-page">
      <div>
        <h1 className="text-4xl sm:text-5xl font-headings font-bold">Requests & tasks</h1>
        <p className="text-sm text-muted-foreground mt-2">Everything we need from you, across all the entities you can access.</p>
      </div>
      {items && !items.length && <p className="text-sm text-muted-foreground" data-testid="requests-empty">You're all caught up.</p>}
      <div className="rounded-xl border border-border divide-y divide-border bg-card">
        {items?.map((i) => (
          <div key={`${i.kind}-${i.ref_id}`} className="p-4" data-testid={`request-${i.kind}-${i.ref_id}`}>
            <div className="flex flex-wrap items-center gap-2">
              <Badge variant="outline">{KIND[i.kind] || i.kind}</Badge>
              <span className="rounded bg-primary/10 text-primary px-1.5 py-0.5 text-[11px]">{i.entity_name}</span>
              <span className="text-sm font-medium">{i.title}</span>
              <span className="ml-auto text-xs text-muted-foreground">{i.due_date ? `Due ${d(i.due_date)} · ` : ''}{i.status}</span>
            </div>
            {i.description && <p className="text-sm text-muted-foreground mt-1">{i.description}</p>}
            {i.kind === 'client_action' && i.status === 'outstanding' ? <ActionComplete item={i} onDone={load} />
              : i.kind !== 'client_action' && <Link className="text-xs underline" to={i.link} data-testid={`request-open-${i.ref_id}`}>Open</Link>}
          </div>
        ))}
      </div>
    </div>
  );
}
